import { Pipe } from '@angular/core';
import { isArray } from '../utils/utils';
var HeadPipe = (function () {
    function HeadPipe() {
    }
    HeadPipe.prototype.transform = function (input) {
        if (!isArray(input)) {
            return input;
        }
        // Will return undefined if length is 0
        return input[0];
    };
    return HeadPipe;
}());
export { HeadPipe };
HeadPipe.decorators = [
    { type: Pipe, args: [{
                name: 'head'
            },] },
];
/** @nocollapse */
HeadPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=head.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/array/head.pipe.js
// module id = 235
// module chunks = 103